import { PATH_PAGE } from '~/routes/paths';
import SvgIconStyle from '@components/SvgIconStyle';

const getIcon = (name: string) => (
  <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  dashboard: getIcon('iconly/light/category'),
  twoUsers: getIcon('iconly/light/2_user'),
  agents: getIcon('iconly/light-outline/home'),
  lists: getIcon('iconly/light-outline/list'),
  opportunities: getIcon('dollar_sign'),
  company: getIcon('iconly/light/work'),
};

const navConfig = [
  {
    subheader: '',
    items: [
      { title: 'dashboard', path: PATH_PAGE.loanOfficers.dashboard, icon: ICONS.dashboard },
      {
        title: 'loan officers',
        path: 'loan-officers',
        icon: ICONS.twoUsers,
        children: [
          { title: 'search', path: PATH_PAGE.loanOfficers.search, icon: ICONS.twoUsers },
          { title: 'lists', path: PATH_PAGE.loanOfficers.lists, icon: ICONS.lists },
        ],
      },
      {
        title: 'company',
        path: 'company',
        icon: ICONS.company,
        children: [
          {
            title: 'Company Trends',
            path: PATH_PAGE.loanOfficers.companyTrends.search,
            icon: ICONS.twoUsers,
          },
          { title: 'Employee Trends', path: PATH_PAGE.loanOfficers.trends },
        ],
      },
      {
        title: 'agents',
        path: 'agents',
        icon: ICONS.agents,
        children: [
          { title: 'Agents Search', path: PATH_PAGE.agents.search, icon: ICONS.twoUsers },
          { title: 'Teams Search', path: PATH_PAGE.agents.teams.search, icon: ICONS.twoUsers },
          // { title: 'dashboard', path: PATH_PAGE.dashboard, icon: ICONS.dashboard },
          { title: 'lists', path: PATH_PAGE.agents.lists, icon: ICONS.lists },
        ],
      },
      {
        title: 'opportunities',
        path: 'opportunities',
        icon: ICONS.opportunities,
        children: [
          { title: 'Search', path: PATH_PAGE.opportunities.search, icon: ICONS.opportunities },
          { title: 'lists', path: PATH_PAGE.opportunities.lists, icon: ICONS.lists },
        ],
      },
    ],
  },
];

export default navConfig;
